/*
 * This contains all the text material option
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  noMaterial: {
    id: 'cwt.translations.noMaterial',
    defaultMessage: 'No worktop',
  },
  laminate: {
    id: 'cwt.translations.laminate',
    defaultMessage: 'Laminate',
  },
  acrylic: {
    id: 'cwt.translations.acrylic',
    defaultMessage: 'Acrylic',
  },
  quartz: {
    id: 'cwt.translations.quartz',
    defaultMessage: 'Quartz',
  },
  'solid wood': {
    id: 'cwt.translations.solid-wood',
    defaultMessage: 'Solid Wood',
  },
  wood: {
    id: 'cwt.translations.wood',
    defaultMessage: 'Wood',
  },
  glass: {
    id: 'cwt.translations.glass',
    defaultMessage: 'Glass',
  },
  ceramic: {
    id: 'cwt.translations.ceramic',
    defaultMessage: 'Ceramic',
  },
  porcelain: {
    id: 'cwt.translations.porcelain',
    defaultMessage: 'Porcelain',
  },
});
